import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

export const admin_get_return_requests = createAsyncThunk(
    'return/admin_get_list',
    async ({ status = 'all', page = 1, limit = 20 } = {}, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/admin/return-requests?status=${status}&page=${page}&limit=${limit}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const admin_get_return_request = createAsyncThunk(
    'return/admin_get_one',
    async (id, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/admin/return-requests/${id}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const admin_approve_return = createAsyncThunk(
    'return/admin_approve',
    async ({ id, refundAmount, adminNotes = '' }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put(`/admin/return-requests/${id}/approve`, { refundAmount, adminNotes }, { withCredentials: true })
            return fulfillWithValue({ ...data, id })
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const admin_reject_return = createAsyncThunk(
    'return/admin_reject',
    async ({ id, adminNotes = '' }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put(`/admin/return-requests/${id}/reject`, { adminNotes }, { withCredentials: true })
            return fulfillWithValue({ ...data, id })
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const admin_complete_return = createAsyncThunk(
    'return/admin_complete',
    async ({ id, adminNotes = '' }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put(`/admin/return-requests/${id}/complete`, { adminNotes }, { withCredentials: true })
            return fulfillWithValue({ ...data, id })
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

const returnSlice = createSlice({
    name: 'return',
    initialState: {
        returnRequests: [],
        totalReturns: 0,
        selectedReturn: null,
        successMessage: '',
        errorMessage: ''
    },
    reducers: {
        messageClear: (state) => {
            state.successMessage = ''
            state.errorMessage = ''
        },
        clearSelectedReturn: (state) => {
            state.selectedReturn = null
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(admin_get_return_requests.fulfilled, (state, { payload }) => {
                state.returnRequests = payload.requests
                state.totalReturns = payload.total
            })
            .addCase(admin_get_return_request.fulfilled, (state, { payload }) => {
                state.selectedReturn = payload.request
            })
            .addCase(admin_approve_return.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
                state.returnRequests = state.returnRequests.map(r =>
                    r._id === payload.id ? { ...r, status: 'approved' } : r
                )
                if (state.selectedReturn?._id === payload.id) {
                    state.selectedReturn = { ...state.selectedReturn, status: 'approved' }
                }
            })
            .addCase(admin_reject_return.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
                state.returnRequests = state.returnRequests.map(r =>
                    r._id === payload.id ? { ...r, status: 'rejected' } : r
                )
                if (state.selectedReturn?._id === payload.id) {
                    state.selectedReturn = { ...state.selectedReturn, status: 'rejected' }
                }
            })
            .addCase(admin_complete_return.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
                state.returnRequests = state.returnRequests.map(r =>
                    r._id === payload.id ? { ...r, status: 'completed' } : r
                )
                if (state.selectedReturn?._id === payload.id) {
                    state.selectedReturn = { ...state.selectedReturn, status: 'completed' }
                }
            })
            .addMatcher(
                (action) => action.type.startsWith('return/') && action.type.endsWith('/rejected'),
                (state, { payload }) => {
                    state.errorMessage = payload?.error || payload?.message || 'Something went wrong'
                }
            )
    }
})

export const { messageClear, clearSelectedReturn } = returnSlice.actions
export default returnSlice.reducer
